import { RouteConfig } from 'vue-router';
import MswTenantManagementPage from './msw-tenant-management.vue';

const mswMsspMonthlyPage: RouteConfig = {
  path: 'mssp-tenant-mgmt',
  component: MswTenantManagementPage,
};

export function getDefaultParams() {
  return {};
}

export default mswMsspMonthlyPage;
